import React, { memo, useEffect } from "react";

const FullMockDetails = memo(function FullMockDetails({
	setCheckPoint, mock, setNextFlag
}) {

	useEffect(() => {
		setNextFlag(true);
	}, []);

	return (
		<div className="col-xs-12 successContent">
			<div className="col-lg-12">
				<h4 className="mt-0">Welcome {mock.user_data.first_name} {mock.user_data.last_name}</h4>
				<div className="col-xs-12">
					<table className="table table-bordered">
						<thead>
							<tr>
								<th>Part</th>
								<th>Content</th>
								<th>Time Allowed</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>1</td>
								<td>Speaking & Writing</td>
								<td>{parseInt(mock.mock.speaking_time) + parseInt(mock.mock.writting_time)} minutes</td>
							</tr>
							<tr>
								<td>2</td>
								<td>Reading</td>
								<td>{mock.mock.reading_time} minutes</td>
							</tr>
							{mock.mock.break === 0 ? (
								<tr>	
									<td colSpan={2}>Optional scheduled break</td>	
									<td>10 minutes</td>	
								</tr>
							) : ''}
							<tr>
								<td>3</td>
								<td>Listening</td>
								<td>{mock.mock.listening_time} minutes</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	);
});

export default FullMockDetails;